import { call, put, takeEvery } from "redux-saga/effects";
import { customRequestApisError, customRequestApisSuccess } from "./actions";
import { CUSTOM_REQUEST } from "./actionTypes";
import { getHeader, getHeaderUpload } from "../../resources/headers";
import { handleUnauthorized } from "../../resources/fetchRequest";

function buildQueryString(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === "" || value === null || value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((v) => usp.append(key, String(v)));
    } else {
      usp.append(key, String(value));
    }
  });
  return usp.toString();
}

function extractErrors(errBody, statusCode) {
  // 1. Array estándar: { errors: [{ code, message }] }
  if (Array.isArray(errBody?.errors) && errBody.errors.length > 0) {
    return errBody.errors;
  }
  // 2. error.error.message: { error: { message: "..." } }
  if (errBody?.error?.message) {
    return [{ code: statusCode, message: errBody.error.message }];
  }
  // 3. error.error string: { error: "..." }
  if (typeof errBody?.error === "string" && errBody.error) {
    return [{ code: statusCode, message: errBody.error }];
  }
  // 4. message plano: { message: "..." }
  if (errBody?.message) {
    return [{ code: statusCode, message: errBody.message }];
  }
  // 5. Fallback genérico
  return [{ code: statusCode, message: `HTTP error! Status: ${statusCode}` }];
}

async function customRequestFetch({ method, path, body, queryParams }) {
  const baseUrl = process.env.REACT_APP_HOST_API;
  const qs = buildQueryString(queryParams);
  const sep = path.includes("?") ? "&" : "?";
  const fullUrl = `${baseUrl}${path}${qs ? `${sep}${qs}` : ""}`;

  const isFormData = body instanceof FormData;
  const headers = isFormData ? getHeaderUpload() : getHeader();

  const requestOptions = {
    method: method === "POSTOUTBODY" ? "POST" : method,
    headers,
    ...(body && method !== "GET" && method !== "DELETE"
      ? { body: isFormData ? body : JSON.stringify(body) }
      : {}),
  };

  const response = await fetch(fullUrl, requestOptions);

  if (!response.ok) {
    handleUnauthorized(response.status);
    const errBody = await response.json().catch(() => ({}));
    throw {
      code: response.status,
      errors: extractErrors(errBody, response.status),
    };
  }

  if (method === "DELETE") {
    return { data: [], pagingInfo: { limit: "0", page: "0", totalItems: 0 } };
  }

  const text = await response.text();
  if (!text || !text.trim()) return true;
  try {
    return JSON.parse(text);
  } catch {
    return true;
  }
}

function* handleCustomRequest({ payload }) {
  const { requestKey, ...params } = payload;
  try {
    const response = yield call(customRequestFetch, params);
    yield put(customRequestApisSuccess(response, requestKey));
  } catch (error) {
    yield put(
      customRequestApisError(
        { code: error.code, errors: error.errors ?? [{ code: error.code, message: error.message ?? "Error desconocido" }] },
        requestKey,
      ),
    );
  }
}

function* CustomRequestSaga() {
  yield takeEvery(CUSTOM_REQUEST, handleCustomRequest);
}

export default CustomRequestSaga;
